import React, { useEffect } from "react";
import { LiveKitRoom } from "@livekit/components-react";
import EgressHelper from "@livekit/egress-sdk";
import styles from "./StreamLayoutCanvas.module.css";
import { StreamLayoutCanvasInner } from "../StreamLayoutCanvasInner/StreamLayoutCanvasInner";
import { StreamLayoutCanvasProps } from "../StreamLayoutCanvasInner/StudioTypes";

const StreamLayoutCanvas: React.FC<StreamLayoutCanvasProps> = (props) => {
  const {
    url,
    token,
    isRecordingMode = false,
    className,
    ...otherProps
  } = props;

  useEffect(() => {
    if (isRecordingMode) {
      EgressHelper.startRecording();
    }
  }, [isRecordingMode]);

  return (
    <LiveKitRoom
      serverUrl={url}
      token={token}
      connect={true}
      audio={false}
      video={false}
      className={styles["stream-layout__video-container"]}
    >
      <StreamLayoutCanvasInner
        className={className}
        {...otherProps}
      />
    </LiveKitRoom>
  );
};

export default StreamLayoutCanvas;